import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import ro from "/src/content/ro.json";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(ro.auth.forgot.success);
    } catch (err) {
      setError(ro.auth.forgot.error);
    }
  };

  return (
    <section className="auth-section">
      <div className="auth-card">
        <h2 className="auth-title">{ro.auth.forgot.title}</h2>
        <p className="auth-subtitle">{ro.auth.forgot.subtitle}</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-input-wrap">
            <input
              type="email"
              placeholder={ro.auth.forgot.emailPlaceholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              autoComplete="email"
              required
            />
            <span className="auth-input-icon">
              <Mail size={18} />
            </span>
          </div>
          <button type="submit" className="auth-btn">
            {ro.auth.forgot.submit}
          </button>
        </form>

        {message && <p className="auth-message text-green-600">{message}</p>}
        {error && <p className="auth-message text-red-600">{error}</p>}

        <div className="auth-links">
          <Link to="/login" className="auth-link">
            {ro.auth.forgot.back}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
